export const EVENT_PATH = {
  path: '*/event/:eventId',
};

export const CHECKOUT_PATH = {
  path: '*/purchase/*',
};

export const LOGIN_PATH = {
  path: '*/login*',
};

export const MYACCOUNT_PATH = {
  path: '*/my/*',
};

export const SELLTICKET_PATH = {
  path: '*/sellTicket*',
};

export const SELL_PATH = {
  path: '*/sell*',
};

export const SELL_LISTING_DENIED_PATH = {
  path: '*/sell*/listingDenied*',
};

export const SELL_LISTING_CONFIRMATION_PATH = {
  path: '*/sell*/listingConfirmation*',
};

export const MYACCOUNT_PAYMENTS_CONFIG = {
  path: '*/my/payments/config*', // Required because the config/seller path was clashing with the */sell* rule
};

export const MYACCOUNT_SETTINGS_SELLER_INFO = {
  path: '*/my/settings/seller-info*', // Required because the config/seller path was clashing with the */sell* rule
};

export const HIDEMERCHHEADER_PATH = [EVENT_PATH, CHECKOUT_PATH, LOGIN_PATH, SELLTICKET_PATH, SELL_PATH];
export const HIDEMERCHHEADER_EXCEPTIONS = [
  SELL_LISTING_CONFIRMATION_PATH,
  SELL_LISTING_DENIED_PATH,
  MYACCOUNT_PAYMENTS_CONFIG,
  MYACCOUNT_SETTINGS_SELLER_INFO,
];

export const HIDEFOOTER_PATH = [EVENT_PATH, CHECKOUT_PATH, LOGIN_PATH, SELLTICKET_PATH];

export const HIDE_GOOGLE_SEM_MESSAGE_PATH = [MYACCOUNT_PATH];

export const expandedLayoutPath = (langPath) => {
  return [
    {path: langPath, exact: true},
    {path: '/', exact: true},
    {path: '/:lang?/find/s'},
    {path: `/:seo?${langPath}/category/1`},
    {path: `/:seo?${langPath}/category/28`},
    {path: `/:seo?${langPath}/category/174`},
    // TODO: add other URL path pattern to use `expanded` layout
  ];
};
